$(document).ready(function(){
    
   let loadingElement = '<img src="data:image/gif;base64,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" />';

   // 根据URL参数判断默认赛道：带zhihu参数时默认打开小说赛道
   (function initTrackByUrl(){
       let search = window.location.search.substring(1);
       if(!search) return;
       let params = {};
       search.split('&').forEach(function(item){
           let arr = item.split('=');
           params[decodeURIComponent(arr[0])] = decodeURIComponent(arr[1] || '');
       });
       if(params.hasOwnProperty('zhihu')){
           $('.tgTab span').removeClass('active');
           $('.tgTab span').eq(1).addClass('active');
           $('.tgContent').hide();
           $('.tgContent').eq(1).show();
       }
   })();

   const url = "https://feature.people.cn/"

   function tjAI(){
     let shuPendingData = {};
     let movePendingData = {};
   }

   tjAI.prototype.upFile = function(file){
     var formData = new FormData();
        formData.append('file', file); 

        $('.loading').show();
        $('.loadingBox').html(loadingElement);
        $('.blackBg').show();
        
        $.ajax({
            type: 'POST',
            url: url+"api/vote/upload",
            data: formData,
            dataType: 'json',
            processData: false,
            contentType: false,
            success: function(res) {
                console.log('上传图片信息:', res)
                $('.loading').hide();
                $('.blackBg').hide();
                $('.upImg').addClass('upImg_c');
                $('#p_cover_url').val(res.url)
			
            },
            error: function() {

            }
        })
   }
   tjAI.prototype.upVideo = async function(status){
        if (!file) {
          alert('请选择视频');
          return;
        }
		const MAX_SIZE = 1 * 1024 * 1024 * 1024; 
		console.log(file.size)
		if(file.size > MAX_SIZE){
			alert('视频大小超过1G')
			return
		}
		$('.loading').show();
        $('.loadingBox').html(loadingElement);
        $('.blackBg').show();
		$('#progressText').show();
//        setStatus('准备初始化分片上传...');
		
		const initRes = await $.ajax({
          url: url+'api/zos/direct-upload/init',
          type: 'POST',
          contentType: 'application/json',
          data: JSON.stringify({
            filename: file.name,
			mime_type: "video/mp4",
            file_size: file.size
          })
        });
		
		const uploadId = initRes.upload_id;
        const key = initRes.key;
        const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
        const parts = [];

				for (let i = 0; i < totalChunks; i++) {
					  const partNumber = i + 1;
					  const start = i * CHUNK_SIZE;
					  const end = Math.min(start + CHUNK_SIZE, file.size);
					  const chunk = file.slice(start, end);

//					  setStatus(`正在上传第 ${partNumber}/${totalChunks} 片`);
					
					   const getsign = await $.ajax({
						  url: url+'api/zos/direct-upload/sign-part',
						  type: 'POST',
						  contentType: 'application/json',
						  data: JSON.stringify({
							upload_id: initRes.upload_id,
							key: initRes.key,
							part_number:partNumber
						  })
						});
					
					    const signedUrl = getsign.signed_url;
					
					     const uploadRes = await fetch(signedUrl, {
							method: 'PUT',
							body: chunk
						  })
					
						 const etag = uploadRes.headers.get('ETag')
						 
						 console.log('etag:',etag)
						 
						 parts.push({
							PartNumber: partNumber,
							ETag: etag
						 })

					  // 更新进度
					  const percent = ((partNumber / totalChunks) * 100).toFixed(0);
					  $('#progressText').text(percent+'%');
					  $('#progressBar').val(percent);
				}
		
				const backvideo = await $.ajax({
				  url: url+'api/zos/direct-upload/complete',
				  type: 'POST',
				  contentType: 'application/json',
				  data: JSON.stringify({
					upload_id: uploadId,
					key: key,
					file_size: file.size,
					parts: parts
				  }),
				  
				});
		 
		        console.log('backvideo',backvideo.key)
		
		        $('.loading').hide();
					  $('.blackBg').hide();
            $('#progressText').hide();
            $('.upVideo').addClass('upVideo_c');
				    $('.chenggong').show();
            $('#p_video_url').val(backvideo.url)
		
   }
   tjAI.prototype.getcode = function(phone,captchaVerifyParam,btn){

        var formData = new FormData();
        formData.append('phone', phone);
		    formData.append('CaptchaVerifyParam',captchaVerifyParam)

        $.ajax({
            type: 'POST',
            url: url+'api/vote/sendsms',
            data: formData,
            dataType: 'json',
            processData: false,
            contentType: false,
            success: function(res) {
                // console.log('手机验证码:', res)
                alert(res.message)
                startCountdown(btn);
            },
            error: function(error) {
              alert(JSON.parse(error.responseText).message)
            }
        })
   }

   tjAI.prototype.postShu = function(obj){
        $.ajax({
            type: 'POST',
            url: url+'api/vote/register',
            data: obj,
            dataType: 'json',
            success: function(res) {
                console.log('小说赛道提交结果:', res)
                if(res.code == 0){
                    $('.shu_tip').show();
                    $('.blackBg').show();
                    $('.tip_close').on('click',function(){
                        $('.shu_tip').hide();
                        $('.blackBg').hide();
                    })
                }
                if(res.code != 0){
                    alert(res.message)
                }
            },
            error: function(error) {
              alert(JSON.parse(error.responseText).message)
            }
        })
   }
      tjAI.prototype.postMove = function(obj){
        $.ajax({
            type: 'POST',
            url: url+'api/vote/register',
            data: obj,
            dataType: 'json',
            success: function(res) {
                console.log('音视频赛道提交结果:', res)
                if(res.code == 0){
                    $('.blackBg').show();
                    $('.shu_tip1').show();
                    $('.tip_close1').on('click',function(){
                        $('.shu_tip1').hide();
                        $('.blackBg').hide();
                    })
                }
                if(res.code != 0){
                    alert(res.message)
                }
            },
            error: function(error) {
              alert(JSON.parse(error.responseText).message)
            }
        })
   }
   tjAI.prototype.postMov = function(obj){
    $.ajax({
            type: 'POST',
            url: url+'api/vote/register',
            data: obj,
            dataType: 'json',
            success: function(res) {
                console.log('小说赛道提交结果:', res)
                if(res.code == 0){
                    $('.shu_tip').show();
                    $('.blackBg').show();
                    $('.tip_close').on('click',function(){
                        $('.shu_tip').hide();
                        $('.blackBg').hide();
                    })
                }
                if(res.code != 0){
                    alert(res.message)
                }
            },
            error: function(error) {
              alert(JSON.parse(error.responseText).message)
            }
        })
   }
   //60秒倒计时
   function startCountdown(btn){
       let $btn = $(btn);
       let count = 60;
       $btn.addClass('disabled').css({'pointer-events':'none','opacity':'0.6'});
       $btn.text(count+'秒后重试');
       let timer = setInterval(function(){
           count--;
           if(count <= 0){
               clearInterval(timer);
               $btn.removeClass('disabled').css({'pointer-events':'auto','opacity':'1'});
               $btn.text('获取验证码');
           }else{
               $btn.text(count+'秒后重试');
           }
       },1000);
   }

   //获取验证码
   let captcha = "";
   let isCountDown = false;

   //音视频赛道手机号验证
   $('#p_phone').on('blur',function(){
       let phone = $(this).val();
       if(!validatePhone(phone)){
           alert('请输入正确的手机号格式');
           return false;
       }
   });

   //音视频赛道邮箱验证
   $('#p_email').on('blur',function(){
       let email = $(this).val();
       if(!validateEmail(email)){
           alert('请输入正确的邮箱格式');
           return false;
       }
   });

   //音视频赛道填报方式切换
   const pTeamInputs = ['#p_unit_name','#p_team_contact','#p_team_phone','#p_team_creator'];
   let p_fill_type = "";
   $('#p_fill_type').on('change',function(){
       let type = $(this).val();
       if(type == '团队填报'){
           $('#p_team_container').show();
           p_fill_type = '团队填报';
       }else{
           $('#p_team_container').hide();
           pTeamInputs.forEach(function(id){ $(id).val(''); });
           p_fill_type = '个人填报';
       }
   });

   $('#getCode').on('click',function(){
        if($(this).hasClass('disabled')){
            return false;
        }
        let phone = $('#p_phone').val();
        if(phone == ''){
            alert('联系人电话不能为空')
            return false
        }
        if(!validatePhone(phone)){
            alert('请输入正确的手机号格式');
            return false;
        }

        $('.blackBg').show();
		$('.huaBox').show();

        window.initAliyunCaptcha({
			// 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
			SceneId: "gds8ripc",
			// 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
			mode: "embed",
			// 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
			element: "#captcha-element",
			// 触发验证码弹窗或无痕验证的元素
//			button: "#getcode",
			// 验证码验证通过回调函数
			success: function (captchaVerifyParam) {

				console.log('验证通过:',captchaVerifyParam)
				tjObj.getcode(phone,captchaVerifyParam,'#getCode');
				$('.blackBg').hide();
		        $('.huaBox').hide();
			},
			fail: function (result) {
			  console.error(result);
			},
			getInstance: function (instance) {
			  captcha = instance;
			},
			slideStyle: {
			  width: 360,
			  height: 40,
			},
		  });
   })

   //全局调用
   let tjObj = new tjAI();
   //视频上传
   const CHUNK_SIZE = 10 * 1024 * 1024; // 10MB 一片
   let file = null;

   $('#p_upVideo').on('change',function(e){
		file = e.target.files[0];
		console.log('选择文件:',file)
		tjObj.upVideo(1);
   })

   /*====音视频赛道提交========*/
   //显示版权确认弹窗
   function showPCopyrightModal(){
       $('#blackBg, .blackBg').show();
       $('#p_copyright_modal').show();
   }

   //隐藏版权确认弹窗
   function hidePCopyrightModal(){
       $('#p_copyright_modal').hide();
       $('.blackBg').hide();
   }

   //增加组别选择
   let p_group_name = "";
   $('#p_group_name').on('change',function(){
       p_group_name = $('#p_group_name option:selected').text();
       console.log('组别:',p_group_name)
   })
   //增加类别选择
   let p_category_name = "";
   $('#p_category_name').on('change',function(){
       p_category_name = $('#p_category_name option:selected').text();
       console.log('类别:',p_category_name)
   })

   //封面上传
   $('#p_upFace').on('change',function(e){
		let file = e.target.files[0];
		console.log('选择文件:',file)
		tjObj.upFile(file);
   })

   //音视频点击提交按钮
   $('#p_tijiao').on('click',function(){

        let name = $('#p_name').val();
        let email = $('#p_email').val();
        let phone = $('#p_phone').val();
        let code = $('#p_smsmsg').val();
        let videoname = $('#p_video_name').val();//视频名称
        let video_make_time = $('#p_video_make_time').val();//视频制作时间
        let p_video_desc = $('#p_video_desc').val();
        let p_video_keywords = $('#p_video_keywords').val();///视频关键词
        let p_recommend_unit = $('#p_recommend_unit').val();///推荐单位
        let cover_url = $('#p_cover_url').val();///视频封面
        let p_video_link = $('#p_video_link').val();///视频填报链接
        let p_unit_name = $('#p_unit_name').val();///单位名称
        let p_team_contact = $('#p_team_contact').val();///团队联系人
        let p_team_phone = $('#p_team_phone').val();///团队联系人电话
        let p_team_creator = $('#p_team_creator').val();///团队创建人
        let video_url = $('#p_video_url').val();///视频地址

        if(p_group_name == ''){
            alert('请选择组别');
            return false;
        }
        if(p_category_name == ''){
            alert('请选择类别');
            return false;
        }

        if(name == ''){
            alert('姓名不能为空');
            return false;
        }
        if(email == ''){
            alert('邮箱不能为空');
            return false;
        }
        if(phone == ''){
            alert('手机号不能为空');
            return false;
        }
        if(videoname == ''){
            alert('视频名称不能为空');
            return false;
        }
        if(video_make_time == ''){
            alert('请输入视频制作时间');
            return false;
        }
        if(p_fill_type == ''){
            alert('请选择填报方式');
            return false;
        }

               if(p_fill_type == '团队填报'){
            if(p_unit_name == ''){
                alert('单位名称不能为空');
                return false;
            }
            if(p_team_contact == ''){
                alert('团队联系人不能为空');
                return false;
            }
            if(p_team_phone == ''){
                alert('团队联系人电话不能为空');
                return false;
            }
            if(p_team_creator == ''){
                alert('主创人员不能为空');
                return false;
            }
        }

        if(p_video_desc == ''){
            alert('视频简介不能为空');
            return false;
        }
        if(p_video_desc.length < 50){
            alert('视频简介字数不能小于50');
            return false;
        }
        if(p_video_desc.length > 5000){
            alert('视频简介字数不能超过5000');
            return false;
        }

        if(p_video_keywords == ''){
            alert('请输入视频关键词');
            return false;
        }
        if(cover_url == ''){
            alert('视频封面不能为空');
            return false;
        }
        if(video_url == ''){
            alert('请上传视频');
            return false;
        }

        if(code == ''){
            alert('验证码不能为空');
            return false;
        }



        let data = {
            track:"音视频",
            name: name,
            email: email,
            phone: phone,
            smsmsg: code,
            registration_type:p_fill_type,
            category: p_category_name,
            group_name: p_group_name,
            video_name: videoname,
            cover_url: cover_url,
            video_url: video_url,
            video_desc: p_video_desc,
            keywords: p_video_keywords,
            video_make_time: video_make_time,
            recommend_unit: p_recommend_unit,
            report_url: p_video_link,
            org_name: p_unit_name,
            contact_person: p_team_contact,
            main_creators: p_team_creator,
            contact_phone: p_team_phone,
        }
        tjObj.movePendingData = data;
        showPCopyrightModal();
   });

   //取消按钮
   $('#p_copyright_cancel').on('click',function(){
       hidePCopyrightModal();
       tjObj.movePendingData = null;
   });

   //点击遮罩关闭
   $('.blackBg').on('click',function(){
       if($('#p_copyright_modal').is(':visible')){
           hidePCopyrightModal();
       }
       if($('#shu_copyright_modal').is(':visible')){
           $('#shu_copyright_modal').hide();
           $('.blackBg').hide();
          //  tjObj.shuPendingData = null;
       }
   });

   //确认提交
   $('#p_copyright_confirm').on('click',function(){
       hidePCopyrightModal();
       if(tjObj.movePendingData){
          tjObj.postMove(tjObj.movePendingData);
          tjObj.movePendingData = null;
      }
   });

   //实际提交表单
   function submitPForm(){
       //TODO: 表单验证与提交逻辑
       alert('版权信息已确认，正在提交...');
   }
   /*====音视频赛道提交结束=====/

	/*====小说赛道提交========*/
  function validatePhone(phone){
        return /^1[3-9]\d{9}$/.test(phone);
    }
    function validateEmail(email){
        return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
    }

   //小说赛道手机号验证
   $('#shu_phone').on('blur',function(){
       let phone = $(this).val();
       if(!validatePhone(phone)){
           alert('请输入正确的手机号格式');
           return false;
       }
   });

   //小说赛道邮箱验证
   $('#shu_email').on('blur',function(){
       let email = $(this).val();
       if(!validateEmail(email)){
           alert('请输入正确的邮箱格式');
           return false;
       }
   });

   //小说赛道作品简介字数验证(50~200字)
   $('#shu_zp_desc').on('blur',function(){
       let desc = $(this).val();
       let len = desc.length;
       if(len < 50){
           alert('作品简介至少50字，当前'+len+'字');
           return false;
       }
       if(len > 200){
           alert('作品简介不能超过200字，当前'+len+'字');
           return false;
       }
   });

   //小说赛道获取验证码
   $('#shu_getCode').on('click',function(){
       if($(this).hasClass('disabled')){
           return false;
       }
       let phone = $('#shu_phone').val();
       if(phone == ''){
           alert('手机号不能为空');
           return false;
       }
       if(!validatePhone(phone)){
           alert('请输入正确的手机号格式');
           return false;
       }

       $('.blackBg').show();
       $('.huaBox').show();

       window.initAliyunCaptcha({
           SceneId: "gds8ripc",
           mode: "embed",
           element: "#captcha-element",
           success: function (captchaVerifyParam) {
               console.log('验证通过:',captchaVerifyParam)
               tjObj.getcode(phone,captchaVerifyParam,'#shu_getCode');
               $('.blackBg').hide();
               $('.huaBox').hide();
           },
           fail: function (result) {
               console.error(result);
           },
           getInstance: function (instance) {
               captcha = instance;
           },
           slideStyle: {
               width: 360,
               height: 40,
           },
       });
   })

  let shu_zp_word_count;//作品字数
  $('#shu_zp_word_count').on('change',function(){
    // 根据选择的字数显示对应提示
    shu_zp_word_count = $('#shu_zp_word_count option:selected').text();

  })
  $('#shu_tijiao').on('click',function(){
    let name = $('#shu_name').val();
    let email = $('#shu_email').val();
    let phone = $('#shu_phone').val();
    let code = $('#shu_smsmsg').val();
    let zpname = $('#shu_zpname').val();
    let shu_author_name = $('#shu_author_name').val();
    let shu_zpname = $('#shu_zpname').val();
    let shu_zp_desc = $('#shu_zp_desc').val();
    let shu_zp_keywords = $('#shu_zp_keywords').val();
    let shu_recommend_unit = $('#shu_recommend_unit').val();
  

    if(name == ''){
        alert('姓名不能为空');
        return false;
    }
    if(email == ''){
        alert('邮箱不能为空');
        return false;
    }
    if(phone == ''){
        alert('手机号不能为空');
        return false;
    }
    if(shu_zp_desc == ''){
        alert('作品简介不能为空');
        return false;
    }
    if(shu_zp_desc.length < 50){
        alert('作品简介字数不能小于50');
        return false;
    }
    if(shu_zp_desc.length > 5000){
        alert('作品简介字数不能超过5000');
        return false;
    }
    if(code == ''){
        alert('验证码不能为空');
        return false;
    }
    if(shu_author_name == ''){
        alert('请输入作者笔名');
        return false;
    }
    if(zpname == ''){
        alert('请输入作品名称');
        return false;
    }
    if(shu_zpname == ''){
        alert('请输入小说主角名');
        return false;
    }

    if(shu_zp_word_count == ''){
        alert('请选择作品字数');
        return false;
    }
    if(shu_zp_keywords == ''){
        alert('请输入作品关键词');
        return false;
    }


    let data = {
        track:"小说",
        name: name,
        email: email,
        phone: phone,
        smsmsg: code,
        video_name: zpname,
        word_count: shu_zp_word_count,
        author_pen_name: shu_author_name,
        novel_protagonist: shu_zpname,
        video_desc: shu_zp_desc,
        keywords: shu_zp_keywords,
        recommend_unit: shu_recommend_unit,
    }

    //暂存数据并显示小说赛道版权确认弹窗
    tjObj.shuPendingData = data;
    $('#blackBg, .blackBg').show();
    $('#shu_copyright_modal').show();
  })

  //小说赛道版权确认弹窗-取消
  $('#shu_copyright_cancel').on('click',function(){
      $('#shu_copyright_modal').hide();
      $('.blackBg').hide();
      tjObj.shuPendingData = null;
  });

  //小说赛道版权确认弹窗-确认提交
  $('#shu_copyright_confirm').on('click',function(){
      $('#shu_copyright_modal').hide();
      $('.blackBg').hide();
      if(tjObj.shuPendingData){
          tjObj.postShu(tjObj.shuPendingData);
          tjObj.shuPendingData = null;
      }
  });
  /*====小说赛道提交结束========*/

   //切换
   $('.tgTab span').on('click',function(){
		let index = $(this).index();
        $('.tgTab span').removeClass('active');
        $(this).addClass('active');
        $('.tgContent').hide();
        $('.tgContent').eq(index).show();
   })
   $('#p_subTab span').on('click',function(){
		let index = $(this).index();
        $('#p_subTab span').removeClass('active');
        $(this).addClass('active');
        if(index == 0){
              $('#p_subTab').removeClass('subTab1');
        }
        if(index == 1){
             $('#p_subTab').addClass('subTab1');
        }
        $('.p_tgBox').hide();
        $('.p_tgBox').eq(index).show();
   })


   // 匹配所有锚点a标签
    $('.floatNav a[href^="#"]').on('click',function (e) {
        e.preventDefault(); // 取消原生瞬间跳转
        var target = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(target).offset().top-60
        }, 1000); // 700=滑动时间，毫秒，数值越大滑动越慢
    });

    //滚动
    let wenxueSwiper = new Swiper('#wenxueSwiper', {
      autoplay: true,//可选选项，自动滑动
      slidesPerView:3,
      loop:true,
    })
    let rightSwiper = new Swiper('.rightSwiper', {
      direction: 'vertical',
      autoplay: true,//可选选项，自动滑动
      slidesPerView:2,
      spaceBetween : 10,
      loop:true,
    })

    function isMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|HarmonyOS|OpenHarmony/i.test(navigator.userAgent);
    }

    if(isMobile()){
        
    }



})